"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsRegisterRequest = void 0;
var IsRegisterRequest = /** @class */ (function () {
    function IsRegisterRequest() {
    }
    return IsRegisterRequest;
}());
exports.IsRegisterRequest = IsRegisterRequest;
//# sourceMappingURL=isRegister.request.js.map